// Trả về nhân sự vừa tạo để màn hình xác nhận hiển thị tên + email đã nhận
// thông tin đăng nhập. Mật khẩu KHÔNG nằm trong response — backend gửi thẳng
// qua email cho nhân sự.
import { useMutation } from '@tanstack/react-query';

import { axiosClient } from '@/api/axiosClient';
import { useCallApi } from '@/hooks/useCallApi';
import { MutationOptions } from '@/models';
import { FormHRModel } from '@/modules/hr-management/models';

interface CreatedHRResponse {
  id?: string;
  name?: string;
  phone?: string;
  email?: string;
  password_mail_sent?: boolean;
  // Chỉ có giá trị khi gửi email thất bại (SMTP sai cấu hình).
  generated_password?: string;
}

export function useCreateHR(
  options?: MutationOptions<CreatedHRResponse | undefined, FormHRModel>
) {
  const { handleCallApi } = useCallApi();

  function handler(form: FormHRModel) {
    return handleCallApi<CreatedHRResponse>(
      () => axiosClient.post('/employee/create', form),
      true,
      'Tạo mới Nhân sự thành công'
    );
  }

  return useMutation(handler, options);
}
